// src/routes/KaafiPayRoutes.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Intro from '../pages/kaafipay/intro';
import MadrasaFlyer from '../pages/kaafipay/MadrasaFlyer';

const KaafiPayRoutes = () => {
  return (
    <Routes>
      <Route path="/intro" element={<Intro />} />
      <Route path="/madarasa-flyer" element={<MadrasaFlyer />} />
    </Routes>
  );
};

export default KaafiPayRoutes;
